const documents = {
  noDocuments: "There are no documents",
  prompt: 'Instruction' 
};

export default documents;
